import { createI18n } from "vue-i18n"

const messages = {
    es: {
        // ShipsTable traducciones
        app_title: "ECOBUQ",
        home_p: `Simulador de configurador de medidas en buques para mejorar su eficiencia económica y ambiental, que
            permite el cálculo del <strong>Índice de Eco-eficiencia</strong> y el
            <strong>Índice operativo de la intensidad de carbono</strong> obtenido con las medidas. `,
        headerConf: "Configuracciones",
        toastProgressSpinner: "Espera un momento, por favor...",
        name: "Nombre",
        shipType: "Tipo de Barco",
        requiredEEXI: "EEXI requerido",
        attainedEEXI: "EEXI conseguido",
        actions: "Acciones",
        newShipBtn: "Nuevo Barco",
        userDataTitle: "Datos del usuario/armador",
        shipDataTitle: "Datos del buque",
        generateReportBtn: "Generar Reporte",
        overalCalificationBtn: "Calificación del FuelEU",
        tooltipEditShip: "Editar Barco",
        tooltipNewConfig: "Nueva Modificación",
        tooltipDeleteShip: "Borrar Barco",
        tooltipChart: "Mostrar Gráfica",
        tooltipEditConfig: "Editar Configuración",
        tooltipEditEco: "Editar parte económica",
        tooltipSetBase: "Establecer como configuración base",
        tooltipAlreadyBase: "Esta configuración ya es base",
        tooltipCloneConfig: "Clonar configuración",
        tooltipDeleteConfig: "Borrar configuración",

        dialogChart: "Datos económicos",
        dialogChartSelec: "Seleccione los datos",
        deleteShipDisplay: "¿Estás seguro de que quieres eliminar el barco llamado ",
        deleteConfigDisplay: "¿Estás seguro de que quieres eliminar la configuración llamada ",
        reportDisplay: "¿Qué barcos quieres que salgan en el reporte?",
        qualificationDisplay: "¿Con qué barcos y/o modifciaciones quieres hacer el balance?",
        qualificationResultDisplay: "Resultado del balance",
        qualificationResultText: "El balance de cumplimiento es: ",
        qualificationResultSurplus: "El pooling ha sido válido",
        qualificationResultDeficit: "El pooling no ha sido válido",
        reportErrorMsg: "Debe seleccionar al menos un barco",
        yes : "si",
        no : "no",

        // ShipsTable NEOBUQ traducciones
        app_title_NEO: "NEOBUQ",
        home_p_NEO: `Simulador de medición de los índices <strong>CII, ETS y FuelEU</strong>, que permiten visualizar y analizar los costes
        que supondrán para un buque concreto.`,
        label_CII_NEO : "CII (gCO2/t*mn)",
        label_FuelEU : "Sanción FuelEU (€)",
        label_ETS : "Coste EUA (ETS) (€)",
        tooltipEditFleetName : "Editar nombre Flota",
        tooltipConfirmFleetName : "Confirmar nombre",
        tooltipCalculateCII : "Calcular CII",
        tooltipCalculateETS : "Calcular Coste ETS",
        tooltipCalculateFuelEU : "Calcular FuelEU",

        //EditShip traducciones
        shipName: "Nombre del barco",
        imoNumber: "Número IMO",
        iceClass: "Navegación en hielo",
        grossTonnage: "Arqueo Bruto",
        capacityDeadWeight: "Peso muerto del buque",
        dateKeelLaid: "Fecha de puesta de quilla ",
        dateSigning: "Fecha de contrato",
        dataDelivery: "Fecha de entrega",
        displacementVolume: "Volumen de desplazamiento",
        lengthOverall: "Eslora total",
        lengthbtwPerpendicular: "Eslora entre perpendiculares",
        summerLoad: "Calado en la línea de carga de verano",
        breadth: "Manga",
        shipSpeed: "Velocidad de referencia",
        vTanks: "Capacidad cúbica total de los tanques de carga",
        powerLimitElement:
            "Curvas de velocidad-potencia obtenidas a partir de las pruebas del modelo en la fase final o del informe de las pruebas en el mar",
        vsService: "Velocidad de servicio en las pruebas",
        dwtsService: "Peso muerto al calado de diseño",
        psService: "Potencia del motor principal",
        structuralEnhancement: "Mejoras estructurales voluntarias específicas",
        lwtReferenceDesign: "Desplazamiento en rosca del proyecto de referencia",
        lwtEnhancedDesign: "Desplazamiento en rosca del proyecto mejorado",
        has_csr: "Buques sujetos a las reglas estructurales comunes (CSR)",
        deadweightCSR: "Peso muerto CSR",
        lightweightCSR: "Desplazamiento en rosca CSR",
        has_sideLoaders: "¿Dispone de cargadores laterales?",
        capacityNoSideloaders: "Capacidad sin cargadores laterales",
        capacitySideloaders: "Capacidad con cargadores laterales",
        highSpeedCruise: "Crucero de alta velocidad",
        has_roro_ramps: "¿Dispone de rampas de transbordo?",
        capacityNoRORORamp: "Capacidad sin rampas de transbordo",
        capacityRORORamp: "Capacidad con rampas de transbordo",
        isChemicalTanker: "¿El buque es quimiquero?",
        capacityCorrection: "Corrección de la capacidad para buques con clasificación para navegación en hielo?",
        cb: "Coeficiente de bloque",
        addCrane: "Añadir grúa",
        removeCrane: "Eliminar grúa",
        requiredFields: "Campos Obligatorios",
        save: "Guardar",
        cancel: "Cancelar",
        showInfo: "Mostrar Informe",
        calcRequiredEEXI: "Calculo EEXI requerido",
        create: "Crear",
        description: "Descripción",
        close: "Cerrar",
        totalDistance : "Distancia total recorrida",

        //NEOBUQ-EditShip traducciones
        userName: "Nombre",
        userLastName: "Apellidos",
        userCompany: "Empresa",
        userDNI : "DNI",
        userCIF: "CIF",
        oldRewrittenCII: "CII anual prescrito",
        oldAttainedCII: "CII obtenido",
        warningCII: "AVISO: Los índices del CII son ANTES de los descuentos. No se aplican al CII actual.",
        calcOldPCII: "Calcular CII anual prescrito",
        calcOldACII: "Calcular CII obtenido",

        //FormEditConfigurations

        configName: "Nombre Configuraciión",
        configDescription: "Descripción de la Configuración",
        modifiedGT: "GT Modificado",
        modifiedDWT: "DWT Modificado",
        forceVRefCalc: "Vref calculo forzado",
        factors: "Factores",
        shipDesignEle: "Elementos de diseño específicos del buque",
        capacityFactor: "Factor de capacidad para la limitación técnica/reglamentaria de la capacidad",
        fi: "fi no applicado",
        cubicCapacity: "Factor de corrección de la capacidad cúbica",
        fc: "fc no applicado",
        factorGeneral:
            "Factor para los buques de carga general equipados con grúas y otros equipos relacionados con la carga",
        factorSpeed: "Factor de reducción de velocidad en el mar",
        fw: "fw no applicado",
        factorIce: "Factor para buques de clase hielo con IA o IA Super",
        fm: "fm no applicado",
        capacity: "Capacidad",
        calculate: "Calcular",
        calcEngines : "Calcular motores",
        fj: "fj no applicado",

        //ShipsPartTable

        logger: "Registro EEXI Calculado",
        addAnother: "Añadir otro",
        pendingComponent: "Componente Pendiente",
        confirm: "Confirmar",
        headerAuxiliaryEngineEmissions: "¿Estás seguro de que quieres borrar las emisiones del motor auxiliar llamadas",
        headerAuxiliaryEngineEnergySavings:
            "Está seguro de que desea eliminar el ahorro de energía del motor auxiliar de tipo ",
        headerMainEngineEmissions: "¿Estás seguro de que quieres borrar las emisiones del motor principal llamado ",
        headerMainEngineEnergySavings:
            "¿Está seguro de que desea eliminar el motor principal de ahorro de energía con el tipo ",

        //AddAuxEngineEmissionsComponent

        auxiliaryEngine: "Motor Auxiliar",
        propulsionType: "Tipo de Propulsión",
        fuelType: "Tipo de combustible",
        fuelConsumption: "Consumo de combustible",
        certifiedFuelConsumption: "Consumo específico de combustible certificado",
        electricalPowerConsumption: "Potencia eléctrica consumida",
        averageWeight: "Eficiencia media ponderada del generador",
        shaftMotor: "Motor de eje",
        ratedPower: "Consumo nominal de energía",
        shaftMotorEfficiency: "Eficiencia del motor de eje",
        reliquefaction: "Elemento de licuefacción",
        cargoTank: "LNG Capacidad del tanque de carga",
        cargoTankCapacity: "Capacidad tanque de carga",
        rateGas: "Ratio de evaporación de gas al día",
        rateGasLiq: "Gas de evaporación que debe relicuarse",
        entireGasBoil: "gas de evaporación total",
        highPressureGasCompressor: "Compresor para gas a alta presión",
        lowPressureGasCompressor: "Compresor para gas a baja presión",
        vliquid: "Capacidad total neta de combustible líquido",
        vgas: "Capacidad total neta de combustible de gas",
        kliquid: "Tasa de llenado de los depósitos de combustible líquido",
        kgas: "Tasa de llenado de los depósitos de gas",
        sfcLiquid: "Consumo específico de combustible líquido certificado",
        sfcGas: "Consumo específico de combustible gas certificado",
        sfcmePilot: "Consumo específico de combustible pilot certificado",
        secondFuel: "Segundo tipo de combustible",
        liquid: "liquido",

        //AddAuxEngineEnergeSavingsComponent

        addAuxEngineEnergeSavingsComponentHeader:
            "Tecnologías innovadoras de eficiencia energética de los motores auxiliares",
        energyEfficiency: "Tecnologías de eficiencia energética",
        feffpaeeff: "Suministro de energía",
        feffpaeeff2: "Energía recuperada",

        //AddMainEngineEmissionsComponent

        addMainEngineEmissionsComponentHeader: "Motor principal",
        mcrme: "Potencia nominal instalada",
        shaftGenerator: "Generador acoplado",
        mcrpto: "Potencia nominal del generador de eje",
        powerLimit: "Límite de potencia",
        powerLimitType: "Tipo de límite de potencia",

        //AddMainEngineEnergySavingsComponent

        addMainEngineEnergySavingsComponentHeader:
            "Tecnologías innovadoras de eficiencia energética del motor principal",
        feffpeff: "Reducción de la potencia de propulsión",
        paeeffal: "Potencia auxiliar adicional necesaria para el sistema de lubricación por aire",

        //EconomicForm

        baseConfiguration: "Configuración base",
        miscellaneousCosts: "Costes diversos",
        configuration: "Configuración",
        technicalStopDuration: "Duración de la parada técnica",
        dailyCosts: "Gastos diarios",
        initialInvestment: "Inversión inicial",
        financing: "Financiación",
        amountToFinance: "Importe de la financiación",
        interestRate: "Tipo de interés",
        amortizationPeriod: "Período de amortización",
        discountRate: "Tasa de descuento",
        timeDays: "Días",
        fuelName: "Tipo de combustible",
        price: "Precio",
        annualConsumption: "Consumo anual",
        annualConsumptionType: "Unidad del consumo anual",
        annualPriceIncrease: "Incremento de precio anual",
        //LoggingComponent

        loggingComponentHeader1: "Iniciar sesión",
        loggingComponentHeader2: "Registrarse",
        password: "Contraseña",
        actualPassword: "Contraseña actual",
        newPassword: "Nueva contraseña",
        email: "Email",
        firstName: "Nombre",
        lastName: "Apellidos",
        company: "Compañia/Empresa",
        charge: "Posición",
        sector: "Sector de la empresa",
        password2: "Confirmar contraseña",
        newPassword2 : "Confirmar nueva contraseña",
        loggingText1_1: "¿Eres nuevo en Ecobuq-Neobuq?",
        loggingText1_2: "¿Ya tiene una cuenta?",
        loggingText2_1: "Crear una cuenta.",
        loggingText2_2: " Iniciar sesión con una cuenta.",
        loggingText3_1: "¿Se olvidó de la contraseña?",
        loggingText3_2: "Cambiar contraseña",
        toast1: "Ya existe una cuanta con el mismo email.",
        loggingComponentHeader3: "Cambiar contraseña",
        headerModalLogging : "¿A qué sección quiere ingresar?",
        modalWarning: "AVISO: Para ver datos sobre el CII, ir a NEOBUQ. Los datos del CII de ECOBUQ no están actualizados!",

        //LoggingComponent - ToastMsg
        //pwdIncorrect: "ERROR: Contraseña nueva incorrecta.",
        //pwdChangeError: "ERROR: No se pudo cambiar la contraseña.",

        //CarbonForm
        headerCarbonForm: "Clasificación del Índice de Carbono (ICE)",
        fuelConsumptionPerYear: "Consumo de combustible por año",
        totalDistancia: "Total de distancia recorrida",

        //NEOBUQ - General
        modType : "Tipo",

        //NEOBUQ - CII
        questionShipIce : "¿Es un buque de clase hielo?",
        questionShipTanker : "¿Es un buque tanque lanzadera o realiza operaciones STS (Ship to Ship)?",

        questionShipIceIA : "¿Es un buque de clase hielo IA o IA Super?",
        questionStructuralImprovements : "¿Aplica mejoras estructurales voluntarias específicas?",
        questionIsChemicalTankShip : "¿El barco es un buque tanque quimiquero?",
        questionIsShuttleShip : "¿El barco es un buque tanque lanzadera?",
        questionDoesShipTravel : "¿El barco aplica viajes de buque a buque?",
        questionLightTransport : "¿Está diseñado para el transporte de cargas ligeras?",

        travelDistance : "Distancia viajada para periodos de viaje",
        selectionFCelectrical : "Tipo de consumo eléctrico usado",
        secondInputBox_msg1: "Para contenedores refrigerados",
        secondInputBox_msg1_1: "Tienen capacidad de vigilar el consumo eléctrico",
        secondInputBox_msg1_2: "NO tienen capacidad de vigilar el consumo eléctrico",
        secondInputBox_msg2: "Para sistemas de refrigeración de la carga de buques gaseros y de transporte de GNL",
        secondInputBox_msg3: "Para bombas de descarga eléctrica de los buques tanque",

        daysSea : "Días en el mar",
        daysPort : "Días en puerto",
        numContainers : "Nº contenedores:",

        labelSFOC: "Consumo de combustible específico de los motores que suministran energía eléctrica",
        labelFCs: "Consumo total de combustible utilizado en viajes de buque a buque (STS)",

        anualPrewrittenCII: "CII anual prescrito",
        attainedCII : "CII obtenido",
        buttonPrewrittenCII: "Calcular CII anual prescrito",
        buttonAttainedCII : "Calcular CII obtenido",

        warningFCelectrical : "Sólo se puede seleccionar 1 tipo de FCelectrical a la vez.",

        //ETS
        inputPriceEUA : "Precio EUA",
        questionGWPValues : "¿Qué valores de GWP aplican?",
        year : "Año",
        anualEmissions : "Emisiones anuales",
        emissionRights : "Derechos de emisión",
        costEUA : "Coste EUA",

        //FuelEU
        inputAnualDistanceOnIce : "Distancia anual de navegación en hielo",
        inputWindPower : "Potencia de viento",
        inputShipPropulsionPower : "Potencia de propulsión del buque",
        inputEkVariable : "Electricidad suministrada al buque por punto de conexión en tierra",
        inputMotorLNG: "¿Qué motor LNG ha usado?",

        //FuelEU - InputTable
        anualIceConsumption: "Consumo anual de navegación en hielo",
        additionalEnergyPercentage : "Porcentaje energía adicional",

        //FuelEU - Output
        anualAdjustedConsumption: "Consumo anual ajustado",
        complianceBalance : "Balance de conformidad",
        fuelEUPenalty : "Sanción FuelEU",

        //NEOBUQ - ShipsTable
        headerMod: "Modificaciones",
        newModHeader : "Nueva modificación",
        warningObligatory: "¡Es obligatorio rellenar la tabla de combustibles!",
        tooltipGT : "Debe completarse si es un Ro-ro cargo ship, Ro-Pax vessels o Passenger vessels.",
        tooltipOthers : "Sólo es obligatorio si el buque es de clase hielo.",
        tooltipVd: "Debe completarse si el buque es de clase hielo o aplica mejoras estructurales voluntarias específicas.",

        //NEOBUQ - EditModification
        modifType: "Tipo de modificación",
        reductionPercentage : "Porcentaje de reducción asociado",
        modifDescription : "Descripción de la modificación",
        modifWarning : "AVISO",
        modifWarning_msg1 : "El cambio de combustible no varía el valor del GT.",
        modifWarning_msg2 : "El porcentaje de reducción asociado es puramente orientativo.",
        btnRecalculate : "Recalcular",
        modifSelecction : "Que combustible es afectado por la modificación",

        //NEOBUQ - EconomicPart
        labelModType: "Tipo de modificación",
        neobuqInitialInvestment : "Inversión inicial",
        neobuqFinancing : "Financiación",
        neobuqAmountToFinance : "Importe a financiar",
        nominalInterest : "Tasa de interés/Interés nominal",
        neobuqAmortizationPeriod : "Plazo de amortización (años)",
        annualDiscountRate : "Tasa de descuento anual (%) (para VAN)",
        dailyIncome : "Ingresos diarios",
        paralizationDays : "Días de paralización",
        annualFuelPriceIncrease : "Incremento anual del precio del combustible",

        headerPreMod : "Antes de la modificación",
        headerPostMod : "Después de la modificación",
        ecoWarning_msg1 : "El cambio de combustible no cambia el valor del GT",
        ecoWarning_msg2 : "Al rellenar los datos para un año, el resto de años se rellenarán en proporción",
        ecoWarning : "AVISO",

        variousCosts : "Costes varios",
        fuelPrice : "Precio del combustible",
        results : "Resultados",

        annualFuelCost : "Coste de combustible anual",
        variationVariousCosts : "Variación de costes varios anual",
        loanInterests : "Intereses del préstamo",
        annualProfitability : "Rentabilidad anual",
        van : "VAN actual",
        paralizationCost : "Coste de paralización",

        //NEOBUQ - EcoefficiencyPart
        tableHeader : "Tabla de índices de ecoeficiencia",
        intervalsToShow : "Intervalo de años a mostrar",
        ecoYear: "Año",
        ecoCIIindex : "Índice CII",
        ecoFuelEUIndex : "Índice FuelEU",
        ecoETSIndex : "Índice ETS",

        //NEOBUQ - Report translations
        usersFullName : "Nombre completo",
        shipGeneralData : "Datos generales del barco",
        shipFuelData : "Combustibles del barco",
        shipGWP : "Valores GWP que aplican",
        shipIsChemicalTank : "Es un buque tanque quimiquero",
        questionCanMonitorElectricalConsumption : "¿Puede vigilar el consumo eléctrico?",
        shipModifications : "Modificaciones del barco",
        modifName : "Nombre de la modificación",
        incomeChangeTable : "Tabla de cambio de consumo",
        consumptionBeforeModif : "Consumo antes de la modificación",
        consumptionAfterModif : "Consumo despues de la modificación",
        costsAndVariationsTable : "Tabla de costes y variaciones",
        ecoeficiencyTable : "Tabla de índices de ecoeficiencia",
        evaluationsAndSanctions : "Evaluaciones y sanciones finales",
        carbonIndex : "Índice de carbono",
        sanctionFuelCost : "Coste de la sanción",
        refrigeratedContainers : "Contenedores refrigerados (reefer)",
        electricBombs : "Bombas de descarga eléctricas (discharge)",
        refrigerationSistems : "Sistemas de refrigeración en buques gaseros y GNL (cooling)",
        shipFuelFCelectrical : "Combustible con consumo eléctrico",
        fuelIceTable : "Tabla de consumos por navegación por hielo",
        fuelIceTableMessage : "No hay cambios de consumo para la navegación en hielo",
        goBack : "Atras"
    },
    en: {
        // ShipsTable ECOBUQ traducciones
        app_title: "ECOBUQ",
        home_p: `Simulator for configuring measures on ships 
    to improve their economic and environmental efficiency, which allows the calculation of the 
    <strong>Eco-efficiency Index</strong> and the <strong>the carbon intensity index</strong> obtained with the measures.`,
        headerConf: "Configurations",
        toastProgressSpinner: "Wait a moment, please...",
        name: "Name",
        shipType: "Ship Type",
        requiredEEXI: "Required EEXI",
        attainedEEXI: "Attained EEXI",
        actions: "Actions",
        newShipBtn: "New Ship",
        userDataTitle: "User/Ship owner data",
        shipDataTitle: "Vessel data",
        generateReportBtn: "Generate Report",
        overalCalificationBtn: "FuelEU Qualification",
        tooltipEditShip: "Edit Ship",
        tooltipNewConfig: "New Modification",
        tooltipDeleteShip: "Delete Ship",
        tooltipChart: "Show Chart",
        tooltipEditConfig: "Edit Configuration",
        tooltipEditEco: "Edit Economic",
        tooltipSetBase: "Set as Base",
        tooltipAlreadyBase: "Already Base",
        tooltipCloneConfig: "Clone Configuration",
        tooltipDeleteConfig: "Delete Configuration",

        dialogChart: "Economic Data",
        dialogChartSelec: "Select data",
        deleteShipDisplay: "Are your sure you want to delete the ship called ",
        deleteConfigDisplay: "Are your sure you want to delete the configuration called ",
        reportDisplay: "Which ships do you want to include in the report?",
        qualificationDisplay: "¿Which ships and/or modifications do you to make de balance?",
        qualificationResultDisplay: "Result of the balance",
        qualificationResultText: "The compliance balance is: ",
        qualificationResultSurplus: "The pooling is valid",
        qualificationResultDeficit: "The pooling isn't valid",
        reportErrorMsg: "At least one ship must be selected",
        yes : "si",
        no : "no",

        // ShipsTable NEOBUQ traducciones
        app_title_NEO: "NEOBUQ",
        home_p_NEO: `Simulator to measure the <strong>CII, ETS and FuelEU</strong> index, which allows users visualize and analize the money which
        will cost a concrete ship.`,
        label_CII_NEO : "CII (gCO2/t*mn)",
        label_FuelEU : "FuelEU Penalty (€)",
        label_ETS : "EUA costs (ETS) (€)",
        tooltipEditFleetName : "Edit Fleet name",
        tooltipConfirmFleetName : "Confirm name",
        tooltipCalculateCII : "Calculate CII",
        tooltipCalculateETS : "Calculate ETS Cost",
        tooltipCalculateFuelEU : "Calculate FuelEU",

        //EditShip traducciones
        shipName: "Ship Name",
        imoNumber: "IMO Number",
        iceClass: "Ice Class",
        grossTonnage: "Gross Tonnage",
        capacityDeadWeight: "Deadweight",
        dateKeelLaid: "Keel laying date",
        dateSigning: "Contract signing date",
        dataDelivery: "Ship delivery date",
        displacementVolume: "Displacement Volume",
        lengthOverall: "Length Overall",
        lengthbtwPerpendicular: "Length between perpendiculars",
        summerLoad: "Summer load line draught",
        breadth: "Breadth",
        shipSpeed: "Ship speed",
        vTanks: "Total cubic capacity of the cargo tanks",
        powerLimitElement: "Speed-power curves obtained from model testing at final stage or sea trial report",
        vsService: "Testing service speed",
        dwtsService: "Testing deadweight",
        psService: "Testing main engine power",
        structuralEnhancement: "Ship specific voluntary structural enhancement",
        lwtReferenceDesign: "Reference design lightweight",
        lwtEnhancedDesign: "Enhanced design lightweight",
        has_csr: "Ships under the Common Structural Rules (CSR)",
        deadweightCSR: "Deadweight CSR",
        lightweightCSR: "Light weight CSR",
        has_sideLoaders: "Side loaders are present?",
        capacityNoSideloaders: "Capacity without sideloaders",
        capacitySideloaders: "Capacity with sideloaders",
        highSpeedCruise: "High Speed Cruise?",
        has_roro_ramps: "RO-RO ramp is present?",
        capacityNoRORORamp: "Capacity without RO-RO ramp",
        capacityRORORamp: "Capacity with RO-RO ramp",
        isChemicalTanker: "Chemical Tanker?",
        capacityCorrection: "Capacity correction factor for ice-classed ships?",
        cb: "Block coefficient",
        addCrane: "Add Crane",
        removeCrane: "Remove Crane",
        requiredFields: "Required fields",
        save: "Save",
        cancel: "Cancel",
        showInfo: "Show Info",
        calcRequiredEEXI: "Calc Required EEXI",
        create: "Create",
        description: "Description",
        close: "Close",
        totalDistance : "Total distance traveled",

        //NEOBUQ-EditShip traducciones
        userName: "Name",
        userLastName: "Last Name",
        userCompany: "Company",
        userDNI : "DNI",
        userCIF: "CIF",
        oldRewrittenCII: "Required Anual CII",
        oldAttainedCII: "Attained CII",
        warningCII: "WARNING: Those CII index are BEFORE the discounts. Doesn`t apply to the actual CII.",
        calcOldPCII: "Calculate old required CII",
        calcOldACII: "Calculate old attained CII",

        //FormEditConfigurations

        configName: "Configuration name",
        configDescription: "Configuration description",
        modifiedGT: "modified GT",
        modifiedDWT: "modified DWT",
        forceVRefCalc: "Force Vref Calc",
        factors: "Factors",
        shipDesignEle: "Ship specific design elements",
        capacityFactor: "Capacity factor for technical/regulatory limitation on capacity",
        fi: "fi unapply",
        cubicCapacity: "Cubic capacity correction factor",
        fc: "fc unapply",
        factorGeneral: "Factor for general cargo ships equipped with cranes and other cargo-related gear",
        factorSpeed: "Factor for speed reduction at sea",
        fw: "fw unapply",
        factorIce: "Factor for ice-classed ships having IA or IA Super",
        fm: "fm unapply",
        capacity: "Capacity",
        calculate: "Calculate",
        calcEngines : "Calculate engines",
        fj: "fj unapply",

        //ShipsPartTable

        logger: "EEXI Calc Logger",
        addAnother: "Add another",
        pendingComponent: "Pending Component",
        confirm: "Confirm",
        headerAuxiliaryEngineEmissions: "Are your sure you want to delete the Auxiliary Engine Emissions called",
        headerAuxiliaryEngineEnergySavings:
            "Are your sure you want to delete the Auxiliary Engine Energy Savings whit type ",
        headerMainEngineEmissions: "Are your sure you want to delete the Main Engine Emissions called ",
        headerMainEngineEnergySavings: "Are your sure you want to delete the Main Engine Energy Savings with type ",

        //AddAuxEngineEmissionsComponent

        auxiliaryEngine: "Auxiliary Engine",
        propulsionType: "Propulsion Type",
        fuelType: "Fuel Type",
        fuelConsumption: "Fuel consumption",
        certifiedFuelConsumption: "Certified specific fuel consumption",
        electricalPowerConsumption: "Electrical power consumption",
        averageWeight: "Weighted average efficiency of the generator",
        shaftMotor: "Shaft motor",
        ratedPower: "Rated power consumption",
        shaftMotorEfficiency: "Shaft motor efficiency",
        reliquefaction: "Reliquefaction element",
        cargoTank: "LNG Cargo Tank Capacity",
        cargoTankCapacity: "CargoTankCapacity",
        rateGas: "Rate of boil-off gas per day",
        rateGasLiq: "Boil-off gas to be re-liquefied",
        entireGasBoil: "entire boil-off gas",
        highPressureGasCompressor: "Compressor for supplying high-pressured gas",
        lowPressureGasCompressor: "Compressor for supplying low-pressured gas",
        vliquid: "Total net liquid fuel capacity",
        vgas: "Total net gas fuel capacity",
        kliquid: "Filling rate for liquid fuel tanks",
        kgas: "Filling rate for gas fuel tanks",
        sfcLiquid: "Certified specific liquid fuel consumption",
        sfcGas: "Certified specific gas fuel consumption",
        sfcmePilot: "Certified specific pilot fuel consumption",
        secondFuel: "Second fuel type",
        liquid: "liquid",

        //AddAuxEngineEnergeSavingsComponent

        addAuxEngineEnergeSavingsComponentHeader:
            "Innovative auxiliary motor electrical energy efficiency technologies",
        energyEfficiency: "Energy efficiency technologies",
        feffpaeeff: "Power supplied",
        feffpaeeff2: "Power recovered",

        //AddMainEngineEmissionsComponent

        addMainEngineEmissionsComponentHeader: "Main engine",
        mcrme: "Rated installed power",
        shaftGenerator: "Shaft generator",
        mcrpto: "Rated power of shaft generator",
        powerLimit: "Power limit",
        powerLimitType: "Power limit type",

        //AddMainEngineEnergySavingsComponent

        addMainEngineEnergySavingsComponentHeader: "Innovative main engine mechanical energy efficiency technologies",
        feffpeff: "Reduction in propulsion power",
        paeeffal: "Additional auxiliary power needed for air lubrication system",

        //EconomicForm

        baseConfiguration: "Base Configuration",
        miscellaneousCosts: "Miscellaneous costs",
        configuration: "Configuration ",
        technicalStopDuration: "Technical stop duration",
        dailyCosts: "Daily costs",
        initialInvestment: "Initial investment",
        financing: "Financing",
        amountToFinance: "Amount to finance",
        interestRate: "Interest rate",
        amortizationPeriod: "Amortization period",
        discountRate: "Discount rate",
        timeDays: "Days",
        fuelName: "Fuel type",
        price: "Price",
        annualConsumption: "Annual consumption",
        annualConsumptionType: "Annual consumption type",
        annualPriceIncrease: "Annual price increase",

        //LoggingComponent

        loggingComponentHeader1: "Sign In",
        loggingComponentHeader2: "Sign Up",
        loggingComponentHeader3: "Change Password",
        password: "Password",
        actualPassword: "Actual Password",
        newPassword: "New password",
        email: "Email",
        firstName: "First Name",
        lastName: "Last Name",
        company: "Company",
        charge: "Position",
        sector: "Sector ",
        password2: "Confirm Password",
        newPassword2: "Confirm new password",
        loggingText1_1: "New to Ecobuq-Neobuq?",
        loggingText1_2: "Already have an account?",
        loggingText2_1: "Create an account.",
        loggingText2_2: " Sign in an account.",
        loggingText3_1: "Forgot your password?",
        loggingText3_2: "Change password",
        toast1: "Already exist an account with the same email.",
        headerModalLogging : "Which section do you want to go?",
        modalWarning: "WARNING: To see CII data, check NEOBUQ. ECOBUQ's CII data is not updated!",

        //LoggingComponent - ToastMsg
        //pwdIncorrect: "ERROR: New password incorrect.",
        //pwdChangeError: "ERROR: Password couldn't be changed.",

        //CarbonForm

        headerCarbonForm: "Carbon Index Indicator (CII) Rating",
        fuelConsumptionPerYear: "Fuel consumption per year",
        totalDistancia: "Total distance traveled",

        //NEOBUQ - General
        modType : "Type",

        //NEOBUQ - CII
        questionShipIce : "Is the ship an Ice Type ship?",
        questionShipTanker : "Is the ship a shuttle tanker or does it carry out STS (Ship to Ship) operations?",

        questionShipIceIA : "Is the ship an Ice IA o IA Super Type ship?",
        questionStructuralImprovements : "Does ship specific voluntary structural enhancement apply?",
        questionIsChemicalTankShip : "Is the ship a chemical tanker ship?",
        questionIsShuttleShip : "Is the ship a shuttle tank type ship?",
        questionDoesShipTravel : "Does the ship apply ship-to-ship trips?",
        questionLightTransport : "Is the ship designed to transport light loads?",

        travelDistance : "Distance traveled for voyage periods",
        selectionFCelectrical : "Type of electrical consumption used",
        secondInputBox_msg1: "For refrigerated containers",
        secondInputBox_msg1_1: "Has the ability to monitor electricity consumption",
        secondInputBox_msg1_2: "Does NOT have the ability to monitor electricity consumption",
        secondInputBox_msg2: "For cargo cooling systems on gas carriers and LNG transport vessels",
        secondInputBox_msg3: "For electric discharge pumps on tankers",

        daysSea : "Days at sea",
        daysPort : "Days at port",
        numContainers : "Nº containers",

        labelSFOC: "Specific fuel consumption of the engines that supply electrical energy",
        labelFCs: "Total fuel consumption used on ship-to-ship trips (STS)",

        anualPrewrittenCII: "Anual required CII",
        attainedCII : "Attained CII",
        buttonPrewrittenCII: "Calculate anual required CII",
        buttonAttainedCII : "Calculate attained CII",

        warningFCelectrical : "You can only select 1 type of FCelectrical.",

        //ETS
        inputPriceEUA : "EUA Price",
        questionGWPValues : "Which GWP values apply?",
        year : "Year",
        anualEmissions : "Anual emissions",
        emissionRights : "Emission rights",
        costEUA : "EUA cost",

        //FuelEU - input
        inputAnualDistanceOnIce : "Anual distance traveled through ice",
        inputWindPower : "Wind power",
        inputShipPropulsionPower : "Ship propulsion power",
        inputEkVariable : "Electricity supplied to the ship via shore connection point",
        inputMotorLNG: "What LNG motor is being used?",

        //FuelEU - InputTable
        anualIceConsumption: "Anual consupmtion for travels through ice",
        additionalEnergyPercentage : "Additional energy percentage",

        //FuelEU - Output
        anualAdjustedConsumption: "Anual adjusted consumption",
        complianceBalance : "Compliance balance",
        fuelEUPenalty : "FuelEU Penalty",

        //NEOBUQ - ShipsTable
        headerMod: "Modifications",
        newModHeader : "New Modification",
        warningObligatory: "You must add at least one fuel!",
        tooltipGT : "Must be completed if it's a Ro-ro cargo ship, Ro-Pax vessels or Passenger vessels.",
        tooltipOthers : "Must be filled if the ship is an ice class ship.",
        tooltipVd: "Must be filled if the vessel is an ice class ship or applies specific voluntary structural improvements.",

        //NEOBUQ - EditModification
        modifType: "Modification Type",
        reductionPercentage : "Associated reduction percentage",
        modifDescription : "Modification description",
        modifWarning : "WARNING",
        modifWarning_msg1 : "Changing the fuel type doesn't affect the GT value.",
        modifWarning_msg2 : "The associated reduction percentage is purely indicative.",
        btnRecalculate : "Recalculate",
        modifSelecction : "Which fuel is afected by the modification",

        //NEOBUQ - EconomicPart
        labelModType: "Modification type",
        neobuqInitialInvestment : "Initial investment",
        neobuqFinancing : "Financing",
        neobuqAmountToFinance : "Amount to finance",
        nominalInterest : "Interest rate/Nominal interest",
        neobuqAmortizationPeriod : "Amortization period (years)",
        annualDiscountRate : "Annual discount rate (%) (for VAN)",
        dailyIncome : "Daily income",
        paralizationDays : "Days of paralization",
        annualFuelPriceIncrease : "Annual fuel price increase",

        headerPreMod : "Before the modification",
        headerPostMod : "After the modification",
        ecoWarning_msg1 : "Changing the fuel does not change the GT value.",
        ecoWarning_msg2 : "When filling in the data for one year, the rest of years will be filled in proportionally.",
        ecoWarning : "WARNING",

        variousCosts : "Other costs",
        fuelPrice : "Fuel price",
        results : "Results",

        annualFuelCost : "Annual fuel cost",
        variationVariousCosts : "Annual variation of other costs",
        loanInterests : "Loan interests",
        annualProfitability : "Annual profitability",
        van : "Actual VAN",
        paralizationCost : "Paralization cost",

        //NEOBUQ - EcoefficiencyPart
        tableHeader : "Eco-efficiency indices table",
        intervalsToShow : "Year range to display",
        ecoYear: "Year",
        ecoCIIindex : "CII Index",
        ecoFuelEUIndex : "FuelEU Index",
        ecoETSIndex : "ETS Index",

        //NEOBUQ - Report translations
        usersFullName : "Full name",
        shipGeneralData : "General vessel information",
        shipFuelData : "Vessel fuels",
        shipGWP : "GWP valors that apply",
        shipIsChemicalTank : "Is chemical tank vessel",
        questionCanMonitorElectricalConsumption : "Can it monitor electricity consumption?",
        shipModifications : "Vessel modifications",
        modifName : "Modification name",
        incomeChangeTable : "Consumption change table",
        consumptionBeforeModif : "Consumption before the modification",
        consumptionAftedModif : "Consumption after the modification",
        costsAndVariationsTable : "Costs and variations table",
        ecoeficiencyTable : "Ecoeficiency table",
        evaluationsAndSanctions : "Final evaluations and sanctions",
        carbonIndex : "Carbon index",
        sanctionFuelCost : "Sanction",
        refrigeratedContainers : "Refrigerated containers (reefer)",
        electricBombs : "Electric discharge bombs (discharge)",
        refrigerationSistems : "Refrigerated sistems for gas carriers and GNL (cooling)",
        shipFuelFCelectrical : "Fuel with electrical consumption",
        fuelIceTable : "Consumption table for ice navigation",
        fuelIceTableMessage : "There's not any changes to consumption for ice navigation",
        goBack : "Back"
    }
}

const i18n = createI18n({
    locale: "es",
    fallbackLocale: "en",
    messages
})

export default i18n
